import React, { useState, useEffect } from 'react';
import './CalendarHome.css';

function Calendar({ date, eventDates }) {
  const [calendarData, setCalendarData] = useState([]);
  const [hoveredEvent, setHoveredEvent] = useState(null); // Track individual hovered event
  const [hoverPosition, setHoverPosition] = useState({ x: 0, y: 0 });
  const [isHovering, setIsHovering] = useState(false);

  // Generate calendar data for the current month
  const generateCalendar = () => {
    const year = date.getFullYear();
    const month = date.getMonth();
    const daysInMonth = new Date(year, month + 1, 0).getDate();
    const firstDay = (new Date(year, month, 1).getDay() + 6) % 7

    const calendarArray = [];
    let dateCounter = 1;

    for (let i = 0; i < 6; i++) {
      const week = [];
      for (let j = 0; j < 7; j++) {
        if ((i === 0 && j < firstDay) || dateCounter > daysInMonth) {
          week.push(null);
        } else {
          week.push(dateCounter++);
        }
      }
      calendarArray.push(week);
      if (dateCounter > daysInMonth) break;
    }

    setCalendarData(calendarArray);
  };

  useEffect(() => {
    generateCalendar();
  }, [date]);

  const getEventsForDay = (day) => {
    const year = date.getFullYear();
    const month = date.getMonth();
    const currentDayDate = new Date(year, month, day);

    return eventDates.filter((eventDate) => {
      const eventStart = new Date(eventDate.eventDate);
      eventStart.setHours(0, 0, 0, 0);

      const eventEnd = eventDate.eventEndDate ? new Date(eventDate.eventEndDate) : eventStart;
      eventEnd.setHours(0, 0, 0, 0);
      
      return (currentDayDate >= eventStart) && (currentDayDate <= eventEnd);
    });
  };

  const handleMouseEnter = (e, event) => {
    const rect = e.target.getBoundingClientRect();
    setIsHovering(true);
    setHoveredEvent(event); // Set the hovered event
    setHoverPosition({
      x: rect.left - 320, // Adjust for positioning
      y: rect.top - 20,   // Align popup vertically with slight offset
    });
  };

  const handleMouseLeave = () => {
    setIsHovering(false);
    setHoveredEvent(null); // Clear the hovered event when the mouse leaves
  };

  const getStatusClassName = (status) => {
    switch (status) {
      case 'Under review':
        return 'highlight yellow';
      case 'Pending documentation':
        return 'highlight electricpink';
      case 'Open event':
        return 'highlight lightblue';
      case 'Draft':
        return 'highlight lavender';
      case 'Completed':
        return 'highlight blue';
      case 'Attendance confirmed':
        return 'highlight green';
      case 'Cancel':
        return 'highlight darkgray';
      case 'Rejected':
        return 'highlight red';
      default:
        return '';
    }
  };

  return (
    <div className="calendar">
      <div className="table-responsive">
        <table className="table">
          <thead>
            <tr>
              <th>Mon</th>
              <th>Tue</th>
              <th>Wed</th>
              <th>Thu</th>
              <th>Fri</th>
              <th>Sat</th>
              <th>Sun</th>
            </tr>
          </thead>
          <tbody>
            {calendarData.map((week, index) => (
              <tr key={index}>
                {week.map((day, idx) => (
                  <td key={idx}>
                    {day && (
                      <div className="highlight-container">
                        <span className="date-text">{day}</span>
                        <div className="circles-container">
                          {/* Generate a circle for each event */}
                          {getEventsForDay(day).map((event, eventIdx) => (
                            <span
                              key={eventIdx}
                              className={getStatusClassName(event.eventStatus)}
                              onMouseEnter={(e) => handleMouseEnter(e, event)} // Mouse enter for each circle
                              onMouseLeave={handleMouseLeave} // Mouse leave for each circle
                            ></span>
                          ))}
                        </div>
                      </div>
                    )}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {hoveredEvent && isHovering && (
        <div
          className="event-popup"
          style={{
            position: 'absolute',
            top: `${hoverPosition.y}px`,
            left: `${hoverPosition.x}px`,
            zIndex: 1000,
            backgroundColor: '#021354',
            borderRadius: '8px',
            padding: '15px',
            boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
            width: '300px',
            color: '#fff',
          }}
        >
          <div style={{ marginBottom: '10px' }}>
            <h5>{hoveredEvent.eventTitle}</h5>
            <p>
              Event date: {new Date(hoveredEvent.eventDate).toLocaleDateString('en-US', {timeZone: 'UTC'})} to{' '}
              {new Date(hoveredEvent.eventEndDate).toLocaleDateString('en-US', {timeZone: 'UTC'})}
            </p>
            <p> Created by {hoveredEvent.requestedBy} on {new Date(hoveredEvent.createdDate).toLocaleDateString('en-US', {timeZone: 'UTC'})}</p>
            <p> Status: {hoveredEvent.eventStatus.toUpperCase()}</p>
          </div>
        </div>
      )}
    </div>
  );
}

export default Calendar;
